module.exports = __webpack_public_path__ + "img/banner.5.36e14fcd.png";